import { css } from 'styled-components';

/**
 * Collapses a list of individually bordered rows into a single card: rows sit flush,
 * adjacent rows share one hairline, and only the outer corners stay rounded.
 *
 * `wrapper` is the antd row class for the control in use — `.ant-radio-wrapper` or
 * `.ant-checkbox-wrapper`.
 */
export const groupedListStyles = (wrapper: string) => css`
  gap: 0;
  ${wrapper} {
    border-radius: 0;
    /* Rows pull up by the border width so neighbours share one hairline
       instead of stacking two. */
    margin-bottom: -1px;
    position: relative;
    &:first-of-type {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
    &:last-of-type {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      margin-bottom: 0;
    }
    /* The selected row is called out by its tint alone, so it keeps the shared hairline. */
    &${wrapper}-checked {
      border-color: var(--clr-border-grey-100);
    }
    /* Lifted so the hover tint fills the row's full height instead of being
       clipped by the neighbour overlapping the shared hairline. */
    &:hover {
      z-index: 1;
    }
  }
`;
